import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import img1 from "../../assets/images/cart/img1.png";
import img2 from "../../assets/images/cart/img2.png";
import img3 from "../../assets/images/cart/img3.png";
import img4 from "../../assets/images/cart/img4.png";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { Mail } from "../../components/Mailbox";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { removeFromCart } from "../../appRedux/actions-reducer";
import { axiosInstance } from "../../axiosInstance";
import { toast } from "react-toastify";
import { Header } from "../../components/header";

export function ShoppingCart({ headerCart }) {
  // const cartItems = useSelector((state) => state.cart.cartItems);
  // const dispatch = useDispatch();

  const [cartproducts, setcartProduct] = useState([]);
  const [quantity, setQuantity] = useState(1);
  // const[clothingid,setclothingId]=useState();

  const handleIncrease = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleDecrease = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1)); // Prevent going below 1
  };
  async function addtoCart(id) {
    const userId = localStorage.getItem("user_id");

    const requestData = {
      userId: userId,
      clothingId: id,
      quantity: 1,
    };
    try {
      const response = await axiosInstance.post(`/addtocart`, requestData);
      if (response.data.status === 200) {
        toast.success(response.data.message || "Added Successfully");
      } else {
        toast.error("Something went wrong, please try again!");
      }
    } catch (error) {
      console.error("Submission failed:", error);
      toast.error("Submission failed! Please try again.");
    }
  }

  async function getCardDetails() {
    const userid = localStorage.getItem("user_id");
    try {
      const response = await axiosInstance.get(`/getCartdata/${userid}`);
      const data = response.data.data;
      // const cartcount=data.length;
      // setcartProduct(data);
      // console.log("cardData", data);
      // localStorage.setItem("cart_count",cartcount);
      // updateHeader();
      // <Header count={data.length}/>

      // Filter out the 'count' object and only display products
      const products = data.filter((item) => item.cart_id); // Assuming 'cart_id' is only present in product objects
      setcartProduct(products);
      console.log("cardData", products);
    } catch (error) {
      console.log(error);
    }
  }
  async function deleteCart(cartid) {
    try {
      const response = await axiosInstance.delete(`/deleteCart/${cartid}`);
      if (response.data.status === 200) {
        toast.success(response.data.message || "Deleted Successfully!");
        getCardDetails();
        headerCart();
      } else {
        toast.error("Something went wrong, please try again!");
      }
    } catch (error) {
      console.log("Error while deleting the cartitem", error);
      toast.error("Deleting failed! Please try again.");
    }
  }
  useEffect(() => {
    console.log("Cart", cartproducts);
    getCardDetails();
  }, []);
  return (
    <div className="HomeMainContainer container">
      <div className="account-title">SHOPPING CART</div>
      <Breadcrumb className="custom-breadcrumb">
        <Breadcrumb.Item href="/">HOME</Breadcrumb.Item>
        <Breadcrumb.Item href="/cart">SHOPPING CART</Breadcrumb.Item>
      </Breadcrumb>
      <div className="cart-subcontainer">
        <div className="cart-products">
          <div className="cart-header">
            <div>Product</div>
            <div>Price</div>
            <div>Quantity</div>
            <div>Total</div>
          </div>
          <div className="cart-body">
            {cartproducts.map((product) => (
              <div className="cart-product">
                <div className="productDetails">
                  <div className="productImg">
                    <img src={product.image ? product.image : "--"} />
                  </div>
                  <div>
                    <div className="product-name">
                      {product.product_name ? product.product_name : "--"}
                    </div>
                    <div className="product-subname">
                      {product.saree_name ? product.saree_name : "--"}
                    </div>
                    <div className="product-details">
                      Size : {product.size ? product.size : "--"}
                    </div>
                  </div>
                </div>
                <div className="product-prices">
                  ₹ {product.price ? product.price : "---"}/-
                </div>
                <div>
                  <span className="product-count">
                    <button
                      onClick={() => {
                        handleDecrease();
                      }}
                    >
                      {" "}
                      -{" "}
                    </button>
                    {quantity}
                    <button
                      onClick={() => {
                        handleIncrease();
                        addtoCart(product.id);
                      }}
                    >
                      +
                    </button>
                  </span>
                </div>
                <div className="product-total">
                  <div>₹ {product.total ? product.totol : "---"}</div>
                  <div onClick={() => deleteCart(product.cart_id)}>
                    <IoIosCloseCircleOutline />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="order-summary">
          <div className="order-summaryTitle">Order Summary</div>
          <div className="order-list">
            <div>Total Items</div>
            <div>4</div>
          </div>
          <div className="order-list">
            <div>Sub Total</div>
            <div>₹50000.00</div>
          </div>
          <div className="order-list">
            <div>Shipping</div>
            <div>₹100.00</div>
          </div>
          <div className="order-list">
            <div>Taxes</div>
            <div>₹0.00</div>
          </div>
          <div className="order-list">
            <div>Discount</div>
            <div className="text-success">₹1000.00</div>
          </div>
          <div className="order-total">
            <div>Total</div>
            <div>₹49100.00</div>
          </div>
          <div className="orderBtnContainer">
            <div className="btnProceed">
              <Link to="/checkout">
                <button>Proceed to Checkout</button>
              </Link>
            </div>
            <div className="btnContinue">
              <button>Continue Shopping</button>
            </div>
          </div>
        </div>
      </div>
      <Mail />
    </div>
  );
}
